import { useEffect, useState } from 'react';


const getWidth = () => {
    return Math.min(window.innerWidth, document.documentElement.clientWidth);
};

export const useWidth = () => {
    const [width, setWidth] = useState(getWidth());

    useEffect(() => {
        const windowResizeListener = () => {
            setWidth(getWidth());
        };

        window.addEventListener('resize', windowResizeListener);

        return () => {
            window.removeEventListener('resize', windowResizeListener);
        };
    }, []);

    return width;
};